import Cookies from 'js-cookie'

export default function authHeader () {
  const token = Cookies.get('base:token')

  if (token) {
    return { Authorization: 'Bearer ' + token }
  } else {
    return {}
  }
}
